import { Grid, RACModalCard, CircularProgress } from '@rentacenter/racstrap';
import { InventoryStyles } from '../../../JsStyles/InventoryStyles';
import React from 'react';

export function LoadingScreen() {
  const classes = InventoryStyles();
  return (
    <>
      <RACModalCard
        className={classes.loaderBackground}
        isOpen={true}
        closeIcon={false}
        maxWidth={'xs'}
        borderRadius={0}
      >
        {
          <Grid>
            <CircularProgress />
          </Grid>
        }
      </RACModalCard>
    </>
  );
}
